// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import ScrollSmooth from './modules/Animation/scrollLenis'
import AnimationElements  from './modules/Animation/enterElements'
import Footer from './modules/Layouts/footer'
import AnchorLinks from './modules/Utils/anchor_links'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import forms from './modules/Forms/forms';
import changeCities from './modules/Forms/changeCities';
import form from './modules/Forms/form';
import login from './modules/Forms/login';
import recovery from './modules/Forms/recovery';
import Menu from './modules/Layouts/menu';
import cookies from './modules/Layouts/cookies';

cookies();
//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
//forms
form();
forms();
login();
recovery();
changeCities();

// Animations
//ScrollSmooth()
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()

// Utils
//AnchorLinks()

// Layout
Menu()
Footer()
